/**
 * Shrinks a text element so it never overflows its container — the CSS class on the
 * element (e.g. a fluid .fs-* helper) stays the upper bound, the width the lower.
 *
 * data-fit-text is the text element
 * data-fit-text-bounds is the ancestor whose width the text has to fit into
 *
 * Siblings in the same row (icons, flex gaps) are accounted for automatically.
 */

const elements = document.querySelectorAll('[data-fit-text]')

const fit = (element) => {
  const bounds = element.closest('[data-fit-text-bounds]')
  if (!bounds) return

  // reset first so the CSS (fluid) size is the measuring base on every resize
  element.style.fontSize = ''

  const row = element.parentElement
  const textWidth = element.getBoundingClientRect().width
  if (!textWidth) return

  const siblingsWidth = row.getBoundingClientRect().width - textWidth
  const available = bounds.clientWidth - siblingsWidth
  if (available <= 0 || textWidth <= available) return

  const fontSize = parseFloat(window.getComputedStyle(element).fontSize)
  element.style.fontSize = `${(fontSize * available) / textWidth}px`
}

const fitAll = () => elements.forEach(fit)

if (elements.length) {
  fitAll()
  // measurements are only reliable once styles and webfonts are in
  window.addEventListener('load', fitAll)
  document.fonts?.ready.then(fitAll)

  let frame
  window.addEventListener('resize', () => {
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(fitAll)
  })
}
